import {
	axiosApi
} from "./api.js";
// 登录接口
// export let loginInt = fromdata => {
// 	return axiosApi({
// 		url: "/outer/login/loginInt",
// 		method: "get",
// 		params: {
// 			params: fromdata
// 		}
// 	});
// };
// 专利添加
// export let AddPatentInterface = (fromdata) => {
// 	return axiosApi({
// 		url: "/api/patent",
// 		method: "post",
// 		data:fromdata
// 	});
// };
// 审批页面  /api/audit/list  status=1就是审核中
export let auditList = fromdata => {
	return axiosApi({
		url: "/api/ip/list",
		method: "get",
		params: fromdata
	});
};
// /api/audit/get?id=xx&type=XX 查看具体的某一个审核
// export let auditList = fromdata => {
// 	return axiosApi({
// 		url: "/api/audit/list",
// 		method: "get",
// 		params: fromdata
// 	});
// };
// 公司：/api/enterprise/list
export let enterpriseList = fromdata => {
	return axiosApi({
		url: "/api/enterprise/list",
		method: "get",
		params: fromdata
	});
};
// 审批人就是用户  调用/api/user/list接口
export let userList = fromdata => {
	return axiosApi({
		url: "api/user/list",
		method: "get",
		params: fromdata
	});
};
